import { PanelItem } from '@hai/ui-react';
import classNames from 'classnames';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Ellipsis } from 'src/js/component/base/ellipsis';
import { constant } from 'src/js/util/constant';
import { LogoModel } from './logos-models';
import { Image } from 'src/js/component/image';
import { GridManagerClientInterface } from 'src/js/component/grid-manager';

export interface Props {
  id: string;
  model: LogoModel;
  gridManager: any | GridManagerClientInterface<LogoModel>;
  selected?: boolean;
  onSelect: (model: LogoModel, selected: boolean) => void;
  onDelete?: (model: LogoModel) => void;
}

export const OneLogo: React.FunctionComponent<Props> = ({
  model,
  gridManager,
  selected,
  onSelect,
  onDelete,
  ...rest
}) => {
  const { t } = useTranslation();
  /*
  const ref = useRef(null);
  useLayoutEffect(() => {
    const gm = gridManager;
    console.log('register',model.name, ref.current);
    gm?.register(model.name, ref.current);
    return () => {
      gm?.unregister(model.name);
    }
  }, [gridManager]);*/

  const ref = useCallback(
    (node: any): any => {
      // console.log('callback of node?', node, gridManager);
      if (node && gridManager) {
        const gm = gridManager;
        const parent = node.parentNode.parentNode; // FIXME do something cleaner, if we had the ref on the correct element it would be more direct.
        gm?.register?.(model.name, parent, model);
      }
    },
    [gridManager],
  );

  const classNamesString = classNames('logo-select', selected && 'selected');
  return (
    <>
      <PanelItem
        /* if we want border to be product color*/
        panelColor={selected ? constant.productColor : undefined} /**/
        className={classNamesString}
        menuItems={onDelete && [{ title: t('general.delete'), onSelect: () => onDelete(model) }]}
        onClick={(e: any) => {
          e.preventDefault();
          if (e.detail === 2) {
            // double click, ignore. NKE-2641
            return true;
          }
          onSelect(model, !selected);
          return false;
        }}
      >
        <div className="box grid" ref={ref}>
          <Image {...rest} className="fs-mask" src={model.thumbnail} />
          <span className="title fs-mask">
            <Ellipsis>{model?.name}</Ellipsis>
          </span>
        </div>
      </PanelItem>
    </>
  );
};
